<template>
    <common-modal @emitEvent="emitEvent($event, ['close'])" @close="emitEvent({ name: 'close' })">
        <common-content-spacer height="large">
            <p class="app-make-referral-menu-header">
                {{ $t('forms.auth.schedule.modals.apply_changes.heading', { locationName: currentLocationOption.label }) }}
            </p>
            <div class="schedule-apply">
                <common-content-spacer height="large">
                    <schedule-summary
                        class="schedule-apply__summary"
                        :locations="locations"
                        :schedule="schedule"
                        :showReversed="true"
                        :showDiscardButton="false"
                    ></schedule-summary>

                    <common-buttons align="justify">
                        <common-button
                            :label="$t('forms.auth.schedule.microcopy.cancel')"
                            type="secondary"
                            size="large"
                            @click="emitEvent({ name: 'discard-changes' })"
                        ></common-button>
                        <common-button
                            :label="$t('forms.auth.schedule.microcopy.save')"
                            type="primary"
                            size="large"
                            @click="emitEvent({ name: 'apply-changes' })"
                        ></common-button>
                    </common-buttons>
                </common-content-spacer>
            </div>
        </common-content-spacer>
    </common-modal>
</template>

<script>
    import { importComponents } from '~/helpers'
    import ScheduleMixin from 'mixins/ScheduleMixin'

    export default {
        mixins: [ScheduleMixin],

        components: {
            ...importComponents(require.context('components/forms/auth-schedule-form')),
        },

        props: {
            currentLocationId: { type: [Number, String], required: true },
            locations: { type: Array, required: true },
            schedule: { type: Object, required: true },
        },
    }
</script>
